module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-5.736a46da.png";